import React from 'react';
import Button from '../../../../../components/Button';
import FixedBottomNavBar from '../../../../../components/FixedBottomNavBar';
import './RecommendStoreSaveNavbar.scss';

const RecommendStoreSaveNavbar = (props) => {
  const { onSubmit } = props;

  return (
    <FixedBottomNavBar className="recommend-store-save-navbar">
      <div className="button-group">
        <Button color="primary" text="등록하기" onClick={onSubmit} />
      </div>
    </FixedBottomNavBar>
  );
};

export default RecommendStoreSaveNavbar;
